import CountdownClock from "./CountdownClock";
import { Box, Typography } from "@mui/material";
import { MintWindowParams } from "../types/mint";

interface Props {
  mintWindowParams: MintWindowParams;
}

const MintCountdownClock = ({ mintWindowParams }: Props) => {
  const { nextMintOpensAt, title } = mintWindowParams;

  return (
    <>
      <Box mb={2} mt={5}>
        <Typography sx={{ fontWeight: 800, display: "inline" }}>
          {title}
        </Typography>{" "}
        closes in
      </Box>
      <CountdownClock dateTime={nextMintOpensAt as number} isCompact={true} />
    </>
  );
};

export default MintCountdownClock;
